<template>
	<div>
		<buttonlist
			@help="help"
			@opentable="opentable"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="SalOtherCostLineViewInfo"
				:filter_language="['negative_flag','charge_invoice_flag','virtual_flag','balancemode_name','invoice_status']"
				:filter_thousandth="['customer_remain_amount','charge_qty','net_unit_price','net_total_amount','base_net_unit_price','base_unit_price','base_net_total_amount','base_total_amount','Other_Material_cost','Other_Man_cost','Other_Charge_cost','year_Other_Material_cost','year_Other_Man_cost','year_Other_Charge_cost']"
				:header="tableHeader"
				:option="tableOption"
				:checkflg="false"
				ref="singleTable"
				></wTable>
		<!--<el-table
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_year" :label="$t('getapi[3677]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_month" :label="$t('getapi[3678]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[3679]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[3680]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>

			<el-table-column show-overflow-tooltip prop="negative_flag" :label="$t('getapi[3705]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="charge_invoice_flag" :label="$t('getapi[3840]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_code" :label="$t('getapi[3681]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="virtual_flag" :label="$t('getapi[3700]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="co_code" :label="$t('getapi[3757]')"></el-table-column>

			<el-table-column show-overflow-tooltip prop="invoice_type_name" :label="$t('getapi[3682]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_date" :label="$t('getapi[3757]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="balancemode_name" :label="$t('getapi[1228]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="customer_code" :label="$t('getapi[2610]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="customer_name" :label="$t('getapi[2958]')"></el-table-column>

			<el-table-column show-overflow-tooltip prop="payment_date" :label="$t('getapi[3686]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[1227]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="exchange_rate" :label="$t('getapi[3287]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="customer_remain_amount" :label="$t('getapi[3689]')" align="right"></el-table-column>
			&lt;!&ndash; <el-table-column show-overflow-tooltip prop="remain_amount" :label="$t('getapi[3688]')" align="right"></el-table-column> &ndash;&gt;

			<el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"  ></el-table-column>
			<el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3691]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="payment_period" :label="$t('getapi[1600]')" align="right"></el-table-column>

			<el-table-column show-overflow-tooltip prop="tax_code" :label="$t('getapi[3693]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="tax_rate" :label="$t('getapi[1225]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="invoice_status" :label="$t('getapi[3694]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="exchange_modify_person" :label="$t('getapi[3695]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="exchange_modify_date" :label="$t('getapi[3696]')" ></el-table-column>

			<el-table-column show-overflow-tooltip prop="audit_period" :label="$t('getapi[3697]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="request_no" :label="$t('getapi[3855]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="request_person" :label="$t('getapi[3856]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="request_date" :label="$t('getapi[3857]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[4551]')" ></el-table-column>

			<el-table-column show-overflow-tooltip prop="charge_name" :label="$t('getapi[2728]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="charge_qty" :label="$t('getapi[1628]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[2009]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="net_total_amount" :label="$t('getapi[2010]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="base_net_unit_price" :label="$t('getapi[2007]')" align="right"></el-table-column>

			<el-table-column show-overflow-tooltip prop="base_unit_price" :label="$t('getapi[3744]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="base_net_total_amount" :label="$t('getapi[2008]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="base_total_amount" :label="$t('getapi[3745]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="contract_info" :label="$t('getapi[2693]')" ></el-table-column>

			<el-table-column show-overflow-tooltip prop="invoicenumlst" :label="$t('getapi[7222]')" ></el-table-column>
			<el-table-column show-overflow-tooltip prop="sal_remark" :label="$t('getapi[3870]')" ></el-table-column>
		</el-table>-->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="SalOtherCostLineViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[3858]')" queryData="SalOtherCostLineViewInfo" tabNo="0" ref="ctab" @getctab="sortclick"></ctable>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'3_salothercostview',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
            dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('3_salothercostview'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
        that.colsort();
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        colsort(){
            let that = this;
            that.$loadviewfields.Fileds('SalOtherCostLineViewInfo',0,PFileds=>{
                that.tableHeader=PFileds;
            });
        },
        sortclick(val){
            if(val==1){
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable(){
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3858]"),this.$t("getapi[3846]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 243, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 243, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('3_salothercostview',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'SalOtherCostLineViewInfo');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let token = JSON.parse(that.userData).token;
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('/Finance/FrmSaleInvoice/GetSalOtherCostLineView', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				} else {
					that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			/*let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
			that.$http.urlpost('/Finance/FrmSaleInvoice/GetSalOtherCostLineViewToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "SalOtherCostLineViewInfo",
                fromname: that.$t('getapi[3858]'),
                SelectIndex: 0,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		},
		//销售关系
		lct(row) {
            let that = this
            that.$store.commit('setSharedParams',row.row);
			let item = {
				label: '采购业务图',
				name: 'purbusiness',
				path: '/purbusiness/receive',
				url: '/purbusiness/receive',
				icon: 'video-play'
			};
			this.$router.push({ path: '/purbusiness/receive'});
			this.$store.commit('selectMenu', item);
            this.$limits.cachePage(item)
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
